import { gt } from '~/locale'

import { Item, ItemContent, ItemImage, ItemImageContainer, ItemsContainer, MainContainer } from './CheckoutFooterShards'
import { FooterItemProps } from './CheckoutFooterTypes'
import { CHECKOUT_FOOTER_ITEMS } from './CheckoutFooterUtils'

const FooterItem = ({ image, content }: FooterItemProps) => {
  return (
    <Item>
      <ItemImageContainer>
        <ItemImage src={image} />
      </ItemImageContainer>
      <ItemContent>{content}</ItemContent>
    </Item>
  )
}

const CheckoutFooterView = () => {
  const items = CHECKOUT_FOOTER_ITEMS(gt).filter(({ hidden }) => !hidden)
  return (
    <MainContainer>
      <ItemsContainer columns={items.length}>
        {items.map(item => (
          <FooterItem key={item.image} image={item.image} content={item.content} />
        ))}
      </ItemsContainer>
    </MainContainer>
  )
}

export default CheckoutFooterView
